import { render, staticRenderFns } from "./RasConfigurazionePostiLettoStanzeEditComponent.vue?vue&type=template&id=6f618439"
import script from "./RasConfigurazionePostiLettoStanzeEditComponent.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoStanzeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports